import { KvixIcon } from "@kvix/ui";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: "12px",
    border: "2px solid #fee9ee",
    background: "transparent",
    transition: "background .25s, border .25s",
    "& .MuiFormControlLabel-root": {
      marginRight: 0,
      padding: "8px 8px 8px 8px",
    },
    "&.MuiFormControl-root:has(.Mui-checked)": {
      border: "2px solid #FD9BB5",
      background: "#fee9ee",
    },
    "& .MuiButtonBase-root": {
      color: "#FA255E !important",
    },
    marginBottom: "20px",
  },
}));

interface Props {
  translations: {
    title: string;
    body: string;
  };
  setMarketing: (checked: boolean) => void;
  isChecked: boolean;
  loading: boolean;
}

export const MarketingCheckbox: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { translations, setMarketing, isChecked, loading } = props;
  
  return (
    <FormControl className={classes.container} fullWidth>
      <FormControlLabel
        control={
          <Checkbox
            disabled={loading}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<KvixIcon.Checkmark.Circled />}
            color={"primary"}
            defaultChecked={!!isChecked}
            onChange={(e) => {
              setMarketing(!!e.target.checked);
            }}
          />
        }
        label={
          <>
            <Typography variant="h6">{translations.title}</Typography>
            <Typography variant="body2">{translations.body}</Typography>
          </>
        }
      />
    </FormControl>
  );
};
